/*! dependencies: scroll-animate-to, axios, popstate */
/*
 *
 * Modules for the list can implement the following:
 * #Properties
 * hideFromQueryString -> Set to true if the keys and values returned from getModuleValue() should not be added to the page query string
 * 
 * #Methods
 * getModuleValue() -> Should return an object with the keys and values the module wants sent to the server
 * 
 * #Events
 * void onServerSuccess(eventArgs) -> Is called when a successfull call is returned from the server
 *   - eventArgs.response -> The response from the server
 *   - eventArgs.ajaxData -> The data sent to the server
 * void onServerError(eventArgs) -> Is called when the server throws an error
 *   - eventArgs.response -> The response from the server
 *   - eventArgs.ajaxData -> The data sent to the server
 * bool onBeforeServerCall(eventArgs) -> Is called Before the server call is made
 *   - eventArgs.ajaxData -> The data sent to the server
 *   - eventArgs.abort -> true if another module have ordered the server call aborted. If true the server call will never be made and this module have no further influence on that
 *   - return -> true if the server call should be aborted
 * void onServerCallAborted(eventArgs) -> Is called after the server call have been aborted
 *   - eventArgs.ajaxData -> The data sent to the server
 * void onServerComplete(eventArgs) -> Is called after success, error or abort
 *   - eventArgs.afterThisEvent -> The event that was fired before this
 *   - eventArgs.? -> The eventargs will depend on which event was fired before
 * 
 */

instant.list = {
  settings: cash.extend({
    moduleClasses: []
  }, instant.settings && instant.settings.list ? instant.settings.list : {}),
  init: function () {
    instant.list.lists = [];
    //console.log('init');
    cash('.list-managed').each(instant.list.initList);
    instant.list.initPopstate();
  },
  initList: function () {
    //console.log('initList');
    var listManaged = cash(this),
      listId = listManaged.attr('id'),
      controllerUrl = listManaged.data('list-ajax-url');

    instant.list.lists[listId] = {
      listManaged: listManaged,
      listId: listId,
      controllerUrl: controllerUrl
    };

    window.setTimeout(function () {
      var moduleEles = cash('[data-list-id=' + listId + ']');
      //console.log('initList', listId, moduleEles);
      instant.list.initModules(listId, moduleEles);
    }, 0);

  },
  initModules: function (listId, moduleEles) {
    instant.list.lists[listId].modules = [];
    moduleEles.each(function () {
      var moduleEle = cash(this),
        moduleClassName = moduleEle.data('list-class'),
        moduleClass = instant.list.settings.moduleClasses[moduleClassName];
      if (moduleClass) {
        //console.log('moduleClass', moduleEle, instant.list.settings.moduleClasses, moduleClassName);
        var moduleObj = new (moduleClass)(moduleEle);
        moduleObj.listId = listId;
        instant.list.lists[listId].modules.push(moduleObj);
      }
    });

    instant.list.lists[listId].listManaged.on('module-changed', function (e, moduleObj) {
      var listId = cash(this).attr('id');
      var moduleValues = instant.list.getModuleValues(listId);
      //console.log('module-changed event', moduleObj, listId, moduleValues);
      instant.list.updateListFromServer(listId, moduleValues, true);
    });
  },
  updateListFromServer: function (listId, moduleValues, updateQueryString) {
    var oldVsNewCompare = window.objectEquals(moduleValues, instant.list.currentAjaxModuleValues);
    //console.log('updateListFromServer', oldVsNewCompare);
    if (!oldVsNewCompare) {
      if (instant.list.currentJQXHR) {
        instant.list.currentJQXHR.abort();
        instant.list.currentJQXHR = null;
      }

      var eventArgs = instant.list.fireEvent(listId, 'onBeforeServerCall', { ajaxData: moduleValues.ajaxData, abort: false });
      //console.log('abort', abort);
      if (eventArgs.abort) {
        instant.list.fireEvent(listId, 'onServerCallAborted', { ajaxData: moduleValues.ajaxData });
        instant.list.fireEvent(listId, 'onServerComplete', { ajaxData: moduleValues.ajaxData, afterThisEvent: 'abort' });
        return;
      }

      instant.list.currentAjaxModuleValues = moduleValues;

      axios.request({
        method: 'POST',
        url: instant.list.lists[listId].controllerUrl,
        data: moduleValues.ajaxData
      }).then(function (response) {
        // handle success
        //console.log('handle success', response);
        instant.list.fireEvent(listId, 'onServerSuccess', { ajaxData: moduleValues.ajaxData, response: response });
        instant.list.fireEvent(listId, 'onServerComplete', { ajaxData: moduleValues.ajaxData, response: response, afterThisEvent: 'success' });
        if (updateQueryString) {
          instant.list.updateQueryString(listId, response, moduleValues.queryStringValues);
        }
        instant.list.scrollToTopOfList(listId);
      }).catch(function (error) {
        // handle error
        //console.log('handle error');
        instant.list.fireEvent(listId, 'onServerError', { ajaxData: moduleValues.ajaxData, response: error });
        instant.list.fireEvent(listId, 'onServerComplete', { ajaxData: moduleValues.ajaxData, response: error, afterThisEvent: 'error' });
      }).then(function () {
        //console.log('always executed');
        // always executed
      });
    }
  },
  getModuleValues: function (listId) {
    var ajaxData = {};
    var moduleQueryStringValues = {};
    for (var i = 0; i < instant.list.lists[listId].modules.length; i++) {
      var module = instant.list.lists[listId].modules[i];
      if (module.getModuleValue && typeof module.getModuleValue === 'function') {
        var moduleValue = module.getModuleValue();
        if (moduleValue) {
          ajaxData = cash.extend(ajaxData, moduleValue);
          //console.log('getModuleValues', module.addModuleValuesToQueryString(), moduleValue);
          if (!module.hideFromQueryString) {
            moduleQueryStringValues = cash.extend(moduleQueryStringValues, moduleValue);
          }
        }
      }
    }
    //console.log('getModuleValues', moduleQueryStringValues);
    return { ajaxData: ajaxData, queryStringValues: moduleQueryStringValues };
  },
  fireEvent: function (listId, eventMethodName, eventArgs) {
    //console.log('fireEvent.' + eventMethodName, eventArgs);
    for (var i = 0; i < instant.list.lists[listId].modules.length; i++) {
      var module = instant.list.lists[listId].modules[i];
      //console.log('module[' + eventMethodName + ']', module[eventMethodName], module);
      if (module[eventMethodName] && typeof module[eventMethodName] === 'function') {
        module[eventMethodName](eventArgs);
      }
    }
    return eventArgs;
  },
  fireOnChanged: function (moduleObj) {
    if (moduleObj) {
      //instant.list.lists[listId].listManaged
      //console.log('fireOnChanged()', instant.list.lists[moduleObj.listId].listManaged);
      instant.list.lists[moduleObj.listId].listManaged.trigger('module-changed', this);
    }
  },
  updateQueryString: function (listId, response, queryStringValues) {
    if (queryStringValues) {
      //console.log('updateQueryString', queryStringValues);
      var url = '';

      cash.each(queryStringValues, function (key, value) {
        //console.log('updateQueryString', key, value);
        var number = parseInt(value);
        url = window.updateQueryString(key, value && (isNaN(number) || number > 0) ? value : null, url);
      });

      //console.log('updateQueryString', url);
      history.pushState(null, null, url);
    }
  },
  initPopstate: function () {
    if (!instant.list.hasInitPopState) {
      instant.list.bindEvents();
      instant.list.hasInitPopState = true;
    }
  },
  bindEvents: function () {
    window.addEventListener('popstate', function (e) {
      var dataFromQueryString = window.queryStringToObject();
      //console.log('popstate 1', dataFromQueryString, instant.list.lists);
      for (var listId in instant.list.lists) {
        //console.log('popstate 2', listId);
        var moduleValues = instant.list.getModuleValues(listId);
        moduleValues.ajaxData = cash.extend(moduleValues.ajaxData, dataFromQueryString);
        moduleValues.queryStringValues = dataFromQueryString;
        //console.log('popstate 3', moduleValues);
        instant.list.updateListFromServer(listId, moduleValues);
      };
    });
  },
  scrollToTopOfList: function (listId) {
    var scrollToElementId = '#' + listId + '-scollTo',
      scrollToElement = cash(scrollToElementId);
    console.log('scrollToTopOfList', scrollToElementId, scrollToElement);
    if (scrollToElement[0]) {
      var scrollIns = new ScrollTo({
        target: scrollToElement[0],
        animationFn: 'easeOut',
        duration: 300
      });
      scrollIns.scroll();
    }
  }
}